/* Petterns - eigen sticky add-to-cart balk (vervangt de Goodst-app).
   - Verschijnt zodra de hoofd-ATC uit beeld scrollt (IntersectionObserver).
   - Spiegelt prijs (van/voor + kortingschip) live uit de buy-zone, zodat
     variant-wissels en app-toeslagen meekomen (MutationObserver).
   - Knop triggert de bestaande hoofd-ATC -> bestaande ajax-cart + drawer.
   - Verbergen bij open overlays gebeurt via CSS (petterns-custom.css). */
(function () {
  'use strict';

  function init() {
    var bar = document.querySelector('[data-sticky-atc]');
    if (!bar) return;

    var sectionId = bar.getAttribute('data-section-id');
    var section = document.getElementById('ProductSection-' + sectionId);
    if (!section) return;

    var mainBtn = section.querySelector('[data-add-to-cart]');
    if (!mainBtn) return;

    // --- knop: trigger de echte hoofd-ATC (draagt variant + aantal mee) ---
    var stickyBtn = bar.querySelector('[data-psa-trigger]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        if (mainBtn.disabled) return;
        mainBtn.click();
      });
    }

    // --- prijs spiegelen uit de buy-zone ---
    var srcSale    = section.querySelector('[data-product-price]');
    var srcWrap    = section.querySelector('[data-product-price-wrap]'); // .hide wanneer geen sale
    var srcCompare = section.querySelector('[data-compare-price]');
    var srcChip    = section.querySelector('[data-discount-chip]');      // .hide wanneer geen korting

    var dstSale    = bar.querySelector('[data-psa-sale]');
    var dstCompare = bar.querySelector('[data-psa-compare]');
    var dstChip    = bar.querySelector('[data-psa-chip]');

    // number-format rendert in shadow DOM -> innerHTML kopiëren werkt niet.
    // We herbouwen een verse <number-format> uit de bron-attributen; die rendert zichzelf.
    var NF_ATTRS = ['number', 'keep-zeros', 'currency', 'locale', 'min-digits', 'max-digits', 'strikethrough'];
    function cloneNF(srcWrapEl) {
      var srcNF = srcWrapEl && srcWrapEl.querySelector('number-format');
      if (!srcNF) return '';
      var nf = document.createElement('number-format');
      NF_ATTRS.forEach(function (a) {
        if (srcNF.hasAttribute(a)) nf.setAttribute(a, srcNF.getAttribute(a));
      });
      nf.className = srcNF.className;
      return nf.outerHTML;
    }

    function syncPrice() {
      if (srcSale && dstSale) dstSale.innerHTML = cloneNF(srcSale);

      if (dstCompare) {
        var onSale = srcWrap ? !srcWrap.classList.contains('hide') : false;
        dstCompare.innerHTML = onSale ? cloneNF(srcCompare) : '';
        dstCompare.classList.toggle('hide', !onSale);
      }

      if (srcChip && dstChip) {
        dstChip.textContent = srcChip.textContent.trim();
        dstChip.classList.toggle('hide', srcChip.classList.contains('hide'));
      }
    }

    function syncBtnState() {
      if (!stickyBtn) return;
      var soldOut = mainBtn.disabled;
      stickyBtn.disabled = soldOut;
      var label = bar.querySelector('[data-psa-btn-text]');
      if (label) label.textContent = soldOut ? bar.getAttribute('data-soldout-text') : bar.getAttribute('data-add-text');
    }

    syncPrice();
    syncBtnState();

    // observer op de buy-zone: vangt variant-wissels en app-rewrites
    var priceObserver = new MutationObserver(function () {
      syncPrice();
      syncBtnState();
    });
    var watchTargets = [srcSale, srcWrap, srcCompare, srcChip, mainBtn].filter(Boolean);
    watchTargets.forEach(function (t) {
      priceObserver.observe(t, {
        childList: true, subtree: true, characterData: true,
        attributes: true, attributeFilter: ['class', 'disabled']
      });
    });
    // theme dispatcht dit bij variantwissel
    document.addEventListener('variant:change', function () {
      setTimeout(function () { syncPrice(); syncBtnState(); }, 0);
    });

    // --- zichtbaarheid: toon zodra de hoofd-ATC uit beeld is ---
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var e = entries[0];
        // toon pas wanneer de hoofdknop voorbij gescrolld is (boven de viewport),
        // niet wanneer hij nog onder de fold zit
        var scrolledPast = !e.isIntersecting && e.boundingClientRect.top < 0;
        setVisible(scrolledPast);
      }, { threshold: 0 });
      io.observe(mainBtn);
    }

    function setVisible(on) {
      bar.classList.toggle('is-visible', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
